module.exports = __webpack_public_path__ + "img/infobutton.7ad0a160.png";